import React, { useState } from "react";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import { useNavigate } from "react-router";

const ProjectCard = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  const [cardColor, setCardColor] = useState(false);
  const navigate = useNavigate();
  const handleCardColorChange = () => {
    setCardColor(true);
  };

  const handleCardColorRemove = () => {
    setCardColor(false);
  };

  const handleNavigation = () => {
    const path = "/projects";
    navigate(path);
  };
  return (
    <div
      onClick={
        title === "Projects" ? () => navigate("/projects") : handleNavigation
      }
      className={`homeCardsView__container__projectCards__card ${cardColor ? `homeCardsView__container__projectCards__cardProject` : ""}`}
      onMouseEnter={handleCardColorChange}
      onMouseLeave={handleCardColorRemove}
    >
      <div className="homeCardsView__container__projectCards__card__iconBox">
        {title === "Projects" ? (
          <LightbulbIcon className="homeCardsView__container__projectCards__cardProject__iconBox__iconProject" />
        ) : (
          <LightbulbIcon
            className={`homeCardsView__container__projectCards__card__iconBox__icon ${cardColor ? `homeCardsView__container__projectCards__cardProject__iconBox__iconProject` : ""}`}
          />
        )}
      </div>
      <p>{title}</p>
      <span>{description}</span>
    </div>
  );
};

export default ProjectCard;
